import { cva } from 'class-variance-authority';

const fileDropZoneBaseStyles = [
  'relative',
  'border',
  'border-2',
  'border-dashed',
  'flex',
  'items-center',
  'justify-center',
  'flex-col',
  'gap-2',
  'w-full',
  'rounded',
  'p-4',
  'cursor-pointer',
  'select-none',
];

const fileDropZoneStylesSAG = cva([
  ...fileDropZoneBaseStyles,
  'border-[#007993]',
  'text-[#007993]',
  'hover:bg-[#D1FFF2]',
  'hover:border-[#005159]',
  'hover:text-[#005159]',

  'dark:border-[#00CCCC]',
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#001F39]',
  'dark:hover:border-[#00FFB9]',
  'dark:hover:text-[#00FFB9]',
]);

const fileDropZoneDisabledStylesSAG = cva([
  ...fileDropZoneBaseStyles,
  'border-[#7D8099]',
  'text-[#7D8099]',
  'cursor-not-allowed',
  'dark:border-[#737389]',
  'dark:text-[#737389]',
  'dark:hover:bg-transparent',
]);

const fileDropZoneStylesSHS = cva([
  ...fileDropZoneBaseStyles,
  'border-[#cf4c00]',
  'text-[#cf4c00]',
  'hover:bg-[#ec660211]',
  'hover:border-[#cf4b00]',
  'hover:text-[#cf4c00]',
]);

const fileDropZoneDisabledStylesSHS = cva([
  ...fileDropZoneBaseStyles,
  'border-[#c2c2c2]',
  'text-[#c2c2c2]',
  'bg-transparent',

  'dark:border-[#3d3d3d]',
  'dark:text-[#3d3d3d]',
  'dark:bg-transparent',
  'cursor-not-allowed',
]);

export {
  fileDropZoneStylesSAG,
  fileDropZoneStylesSHS,
  fileDropZoneDisabledStylesSAG,
  fileDropZoneDisabledStylesSHS,
};
